// extracted by mini-css-extract-plugin
module.exports = {"textEllipsis":"MultiGridTable_textEllipsis__3vX6F"};